import React, { useEffect, useState } from "react";
import { FormGroup, Label, Input, Container } from "reactstrap";

const FilterComponent = () => {
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedRound, setSelectedRound] = useState("");
  const [selectedBeat, setSelectedBeat] = useState("");
  const [selectedComp, setSelectedComp] = useState("");
const [data,setData] = useState([])



  const divisions = [...new Set(data.map((item) => item.divisionName))];
  const ranges = [...new Set(data.filter((item) => item.divisionName === selectedDivision).map((item) => item.rangeName))];
  const rounds = [...new Set(data.filter((item) => item.rangeName === selectedRange).map((item) => item.roundName))];
  const beats = [...new Set(data.filter((item) => item.roundName === selectedRound).map((item) => item.beatName))];
  const comps = [...new Set(data.filter((item) => item.beatName === selectedBeat).map((item) => item.id))];


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("Beats.json"); // Replace with your API endpoint
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }
  , []);

  return (
    <div className="page-content">
      <Container fluid>
    <div>
      <FormGroup>
        <Label for="division">Division</Label>
        <Input type="select" id="division" value={selectedDivision} onChange={(e) => setSelectedDivision(e.target.value)}>
          <option value="">Select Division</option>
          {divisions.map((division) => (
            <option key={division} value={division}>{division}</option>
          ))}
        </Input>
      </FormGroup>
      
      <FormGroup>
        <Label for="range">Range</Label>
        <Input type="select" id="range" value={selectedRange} onChange={(e) => setSelectedRange(e.target.value)} disabled={!selectedDivision}>
          <option value="">Select Range</option>
          {ranges.map((range) => (
            <option key={range} value={range}>{range}</option>
          ))}
        </Input>
      </FormGroup>

      <FormGroup>
        <Label for="round">Round</Label>
        <Input type="select" id="round" value={selectedRound} onChange={(e) => setSelectedRound(e.target.value)} disabled={!selectedRange}>
          <option value="">Select Round</option>
          {rounds.map((round) => (
            <option key={round} value={round}>{round}</option>
          ))}
        </Input>
      </FormGroup>

      <FormGroup>
        <Label for="beat">Beat</Label>
        <Input type="select" id="beat" value={selectedBeat} onChange={(e) => setSelectedBeat(e.target.value)} disabled={!selectedRound}>
          <option value="">Select Beat</option>
          {beats.map((beat) => (
            <option key={beat} value={beat}>{beat}</option>
          ))}
        </Input>
      </FormGroup>

      <FormGroup>
        <Label for="comp">Comp ID</Label>
        <Input type="select" id="comp" value={selectedComp} onChange={(e) => setSelectedComp(e.target.value)} disabled={!selectedBeat}>
          <option value="">Select Comp ID</option>
          {comps.map((comp) => (
            <option key={comp} value={comp}>{comp}</option>
          ))}
        </Input>
      </FormGroup>
    </div>
    </Container>
    </div>
  );
};

export default FilterComponent;